import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { filter, flatten, isEmpty, isNil, map } from 'lodash';
import { getUsableApiKeyEntity, getWebhookUrl, sanitizeApiKeyURL } from 'js/lib/URLUtils';
import { ROUTE_API_KEYS, ROUTE_DESTINATIONS } from 'js/constants/pathnames';
import { CONNECTION_CATEGORY_WEBHOOK } from 'js/constants/connectionCategories';
import UIUtils from '../../../../lib/UIUtils';
import CopyText from '../../../elements/CopyText';
import RoutePrefixContext from '../../../../../new/contexts/RoutePrefixContext';
import ConfigurationFields from '../../../elements/configViews/ConfigurationFields';

class WebhookSourceConfiguration extends Component {
  static contextType = RoutePrefixContext;

  render() {
    const { data, resourceId, config, sink, currentOrg, apiKeys } = this.props;

    const isAutoGenerated = UIUtils.isSourceAutoGenerated(data);
    if (isAutoGenerated) {
      const dataSinkLabel = sink ? sink.name || sink.id : null;
      const sinkInfoContent = dataSinkLabel ? (
        <Link to={`${this.context}${ROUTE_DESTINATIONS}/${sink.id}`}>{dataSinkLabel}</Link>
      ) : null;

      return (
        <div>
          <div className="detail-row single-col">
            <div className="detail-col">
              <div className="detail-key">Auto-generated from Destination</div>
              <div className="detail-value">{sinkInfoContent}</div>
            </div>
          </div>
        </div>
      );
    }

    const usableApiKey = getUsableApiKeyEntity(apiKeys);
    const webhookUrl =
      usableApiKey && 'url' in usableApiKey
        ? usableApiKey.url
        : getWebhookUrl(resourceId, currentOrg, apiKeys);
    const sanitizedWebhookUrl = sanitizeApiKeyURL(webhookUrl);

    const webhookUrlView = <CopyText baseText={webhookUrl} displayText={sanitizedWebhookUrl} />;

    const samplePayload = UIUtils.getWebhookSampleRequest(webhookUrl, sanitizedWebhookUrl, config);

    const samplePayloadView = (
      <CopyText baseText={samplePayload.sample} displayText={samplePayload.sanitizedSample} />
    );

    const { configFields, ...otherProps } = this.props;
    //strip out hidden fields
    let fieldsToDisplay = filter(configFields, (f) => {
      return f.name !== 'hash.enabled';
    });
    let fieldContent = (
      <ConfigurationFields
        {...otherProps}
        configFields={fieldsToDisplay}
        connectionCategory={CONNECTION_CATEGORY_WEBHOOK}
      />
    );

    let apiKeyView = isEmpty(apiKeys)
      ? ''
      : flatten(
          map(apiKeys, (apiKey) => [
            <Link key={apiKey.id} to={`${this.context}${ROUTE_API_KEYS}/${apiKey.id}`}>
              {!isNil(apiKey.name) ? apiKey.name : apiKey.id}
            </Link>,
            ', ',
          ]),
        ).slice(0, -1);

    return (
      <div>
        {fieldContent}
        <div className="detail-row single-col">
          <div className="detail-col">
            <div className="detail-key">Webhook URL</div>
            <div className="detail-value">{webhookUrlView}</div>
          </div>
          <div className="detail-col">
            <div className="detail-key">API Keys</div>
            <div className="detail-value">{apiKeyView}</div>
          </div>
        </div>
        <div className="detail-row  single-col">
          <div className="detail-col">
            <div className="detail-key">Sample Request</div>
            <div className="detail-value">{samplePayloadView}</div>
          </div>
        </div>
      </div>
    );
  }
}

export default WebhookSourceConfiguration;
